import { render, staticRenderFns } from "./MainLedgerCard4Head.vue?vue&type=template&id=0c67f02a"
import script from "./MainLedgerCard4Head.vue?vue&type=script&lang=js"
export * from "./MainLedgerCard4Head.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports